import React, { useEffect, useState } from 'react';
import '../AddReferralModal/AddReferral.css';
import ReferralDS from '../../DataServices/ReferralDs'

import userPoolData from '../../UserPool';
import AWS from 'aws-sdk';
import { insertLog } from '../Logs/InsertLog';
import { useCustomContext } from '../CustomComponents/CustomComponents';

AWS.config.update({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  region: process.env.REACT_APP_AWS_REGION,
});


const cognitoISP = new AWS.CognitoIdentityServiceProvider();
const uploadFileToS3 = async (file, referralID) => {
  const s3 = new AWS.S3({
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
    region: process.env.REACT_APP_AWS_REGION,
  });

  const params = {
    Bucket: process.env.REACT_APP_S3_BUCKET_NAME,
    Key: `${referralID}/${file.name}`, // ✅ Removed 'referrals/' prefix
    Body: file,
    ContentType: file.type,
  };

  try {
    const result = await s3.upload(params).promise();
    console.log("✅ Uploaded:", result.Location);
    return result;
  } catch (error) {
    console.error("❌ Upload failed:", error);
    throw error;
  }
};

export const AddReferralModalLogic = ({ onClose, onSave, onSubmit }) => {
  const [customMake, setCustomMake] = useState("");
  const [customYear, setCustomYear] = useState("");
  const [errors, setErrors] = useState({});
  const [customCounty, setcustomCounty] = useState("")
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [title, setTittle] = useState("")
  const referralAddedBy = localStorage.getItem('email');
  const displayName = referralAddedBy?.split('@')[0] || "";
  const [users, setUsers] = useState([]);



  const handleChange = (e) => {
    const { name, value } = e.target;

    // Clear custom fields if value is not "Other"
    if (name === "vehicleMake" && value !== "Other") {
      setCustomMake("");
    } else if (name === "vehicleYear" && value !== "Other") {
      setCustomYear("");
    } else if (name === "county" && value !== "Other") {
      setcustomCounty("");
    }

    if (name === "phoneNumber") {
      const digitsOnly = value.replace(/\D/g, ""); // remove non-digits
      if (!digitsOnly) {
        setErrors(prev => ({ ...prev, phoneNumber: "Phone number is required" }));
      } else if (digitsOnly.length !== 10) {
        setErrors(prev => ({ ...prev, phoneNumber: "Please enter exactly 10 digits" }));
      } else {
        setErrors(prev => {
          const newErrors = { ...prev };
          delete newErrors.phoneNumber;
          return newErrors;
        });
      }
    }
    if (name === "dob") {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Ignore time part

      const enteredDate = new Date(value);
      enteredDate.setHours(0, 0, 0, 0);

      if (enteredDate > today) {
        
         showAlert(`Future dates are not allowed for Date of Birth.`, [
          { label: "Ok", onClick: () => { }, color: "var(--buttonColor)" }
        ]);
        return; 
      }
    }
    // Update form state for all other fields
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const referal = new ReferralDS();
  const { showAlert, hud, stopHudRotation,showToast } = useCustomContext();

  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    emergencyPhone: "",
    dob: "",
    address: "",
    city: "",
    county: "",
    state: "",
    zip: "",
    vehicleModel: "",
    vehicleColor: "",
    ignitionType: "",
    vin: "",
    DriverlicenseNumber: "",
    licensePlate: "",
    courtName: "",
    courtAddress:"",
    vehicleMake: "",
    vehicleYear: "",
    notes: [],
  });
  const [isDragging, setIsDragging] = useState(false);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    handleFileSelection(e);
    setIsDragging(false);
  };


  const iscountyOther = formData.county === "Other";
  const isOtherSelected = formData.vehicleMake === "Other";
  const isYearOther = formData.vehicleYear === "Other";
  const years = [...Array.from({ length: 2025 - 1990 + 1 }, (_, i) => 1990 + i)];

  const vehicleMakes = [
    "Acura", "Alfa Romeo", "Auston Martin", "Audi", "Bentley", "BMW", "Buick", "Cadillac", "Chevrolet", "Chrysler",
    "Dodge", "Ferrari", "Fiat", "Ford", "Genesis", "GMC", "Honda", "Hyundai", "Infiniti", "Jaguar",
    "Jeep", "Kia", "Lamborgini", "Land Rover", "Lexus", "Lincoln", "Maserati", "McLaren", "Mazda",
    "Mercedes-Benz", "Mini", "Mitsubishi", "Nissan", "Porsche", "Rivian", "Ram", "Rolls-Royce",
    "Subaru", "Tesla", "Toyota", "Volkswagen", "Volvo"
  ];
  const counties = [
    "Atlantic",
    "Bergen",
    "Burlington",
    "Camden",
    "Cape May",
    "Cumberland",
    "Essex",
    "Gloucester",
    "Hudson",
    "Hunterdon",
    "Mercer",
    "Middlesex",
    "Monmouth",
    "Morris",
    "Ocean",
    "Passaic",
    "Salem",
    "Somerset",
    "Sussex",
    "Union",
    "Warren"
  ];
  const useremail = localStorage.getItem("email");
  const userName = useremail?.split('@')[0];


  const handleFileSelection = (e) => {
    e.preventDefault();
    let files = [];

    if (e.dataTransfer?.files) {
      files = Array.from(e.dataTransfer.files); // drag & drop
      console.log("Drag & dropped files:");
    } else if (e.target?.files) {
      files = Array.from(e.target.files); // file input
      console.log("Selected files from input:");
    }

    const validFiles = [];

    for (const file of files) {
      const sizeInMB = file.size / (1024 * 1024);
      if (sizeInMB > 10) {
        showAlert(`${file.name} is more than 10MB. Please select a smaller file.`, [
          { label: "Ok", onClick: () => { }, color: "var(--buttonColor)" }
        ]);
      } else {
        validFiles.push(file);
      }
      // Log each file name here
      console.log(`- ${file.name}`);
    }

    // Combine previous and new valid files
    setSelectedFiles((prev) => [...prev, ...validFiles]);
  };

  useEffect(() => {
    fetchUsers();
  }, []);


  const accessLevel = parseInt(localStorage.getItem("accessLevel"), 10);


  const fetchUsers = async () => {
    hud("Please Wait...");
    try {
      const params = { UserPoolId: userPoolData.userPoolId };
      const data = await cognitoISP.listUsers(params).promise();

      const filteredUsers = data.Users.map(user => {
        const empInfoAttr = user.Attributes.find(attr => attr.Name === 'custom:empInfo');
        const emailAttr = user.Attributes.find(attr => attr.Name === 'email');

        if (!empInfoAttr || !emailAttr) return null;

        try {
          const empInfo = JSON.parse(empInfoAttr.Value);
          const userAccessLevel = parseInt(empInfo.accessLevel, 10);

          if (userAccessLevel === 1) {
            return {
              username: user.Username,
              name: empInfo.name || user.Username,
              accessLevel: userAccessLevel,
              email: emailAttr.Value, // ✅ Extract email from attributes
              Zoho_Referring_Source_ID:empInfo.Zoho_Referring_Source_ID,
            };
          }
        } catch (err) {
          console.warn("Invalid JSON in custom:empInfo:", empInfoAttr.Value);
          return null;
        }

        return null;
      }).filter(Boolean); // remove nulls

      setUsers(filteredUsers);
      console.log("Filtered Users:", filteredUsers);
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      stopHudRotation();
    }
  };



  const countyOptions = [
    { label: "Select County", value: "" },
    ...counties.map(county => ({ label: county, value: county })),
    { label: "Other", value: "Other" }
  ];

  const VechileMakes = [
    { label: "Select Make", value: "" },
    ...vehicleMakes.map(vehicleMake => ({ label: vehicleMake, value: vehicleMake })),
    { label: "Other", value: "Other" }
  ];

  const Years = [
    { label: "Select Year", value: "" },  // placeholder selectable option
    ...years.map(vehicleYear => ({ label: vehicleYear, value: vehicleYear })),
    { label: "Other", value: "Other" }
  ];


  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("handleSubmit called");

    const newErrors = {};
    const { firstName, email, phoneNumber } = formData;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\(?([0-9]{3})\)?[- ]?([0-9]{3})[- ]?([0-9]{4})$/;

    if (!firstName) newErrors.firstName = "First name is required";
    else if (firstName.length > 30) newErrors.firstName = "Max 30 characters";

    if (formData.lastName && formData.lastName.length > 30) {
      newErrors.lastName = "Max 30 characters";
    }

    if (!email) newErrors.email = "Email is required";
    else if (!emailRegex.test(email)) newErrors.email = "Invalid email format";
    else if (email.length > 30) newErrors.email = "Max 30 characters";

    if (!phoneNumber) {
      newErrors.phoneNumber = "Phone number is required";
    } else if (!phoneRegex.test(phoneNumber.replace(/\D/g, ""))) {
      newErrors.phoneNumber = "Please enter exactly 10 digits";
    }
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      console.log("Validation failed:", newErrors);
      showAlert("Please correct the form errors before submitting.", [
        { label: "Ok", onClick: () => { }, color: "#c00" },
      ]);
      return;
    }

    let updatedNotesArray = [];
    if (Array.isArray(formData.notes)) {
      updatedNotesArray = formData.notes.filter(note => note.trim() !== '');
    } else if (typeof formData.notes === "string" && formData.notes.trim()) {
      updatedNotesArray = [formData.notes.trim()];
    }

    let referralAddedBy = useremail;
    let selectedName = ""; // Track attorney name if selected
    let Zoho_Referring_Source_ID = "";
    if ((accessLevel === 2 || accessLevel === 3) && title) {
      const selectedUser = users.find(user => user.username === title);
      if (selectedUser) {
        selectedName = selectedUser.name;
        const noteMessage = `Referral added by ${displayName} on behalf of ${selectedName} (Attorney)`;
        updatedNotesArray = [noteMessage, ...updatedNotesArray];
        referralAddedBy = selectedUser.email || useremail;
        Zoho_Referring_Source_ID = selectedUser.Zoho_Referring_Source_ID;
      }
    }

    const finalData = {
      ...formData,
      notes: updatedNotesArray,
      vehicleMake: formData.vehicleMake === "Other" ? customMake : formData.vehicleMake,
      vehicleYear: formData.vehicleYear === "Other" ? customYear : formData.vehicleYear,
      county: formData.county === "Other" ? customCounty : formData.county,
      referralAddedBy,
      Zoho_Referring_Source_ID,
    };

    console.log("Final data to be submitted:", finalData);

    let referralID = null;

    try {
      hud("Please wait...");
      const response = await referal.RM_INSERT(finalData);
      const data = response.data;

      let parsedBody;
      try {
        parsedBody = JSON.parse(data.body);
        referralID = parsedBody?.referralID;
      } catch (e) {
        console.error("Failed to parse response body:", e);
        showAlert("Invalid response from server. Failed to create referral.", [
          { label: "Ok", onClick: () => { }, color: "#c00" },
        ]);
        stopHudRotation();
        return;
      }

      if (data.statusCode !== 200 || !referralID) {
        showAlert(parsedBody?.message || "Failed to create referral. No ID returned.", [
          { label: "Ok", onClick: () => { }, color: "var(--buttonColor)" },
        ]);
        stopHudRotation();
        return;
      }

      console.log("Referral created successfully with ID:", referralID);

      // ✅ Conditional log message
      await insertLog(
        selectedName
          ? `Referral added by ${displayName} on behalf of ${selectedName} (Attorney) for ${finalData.firstName}`
          : `${userName} created a referral for ${finalData.firstName}`,
        referralID,
        referralAddedBy,
        hud,
        stopHudRotation,
        showAlert
      );

      // ✅ Upload files if present
      if (selectedFiles.length > 0) {
        for (const file of selectedFiles) {
          try {
            await uploadFileToS3(file, referralID);
            await insertLog(
              `${userName} uploaded file ${file.name}`,
              referralID,
              useremail,
              hud,
              stopHudRotation,
              showAlert
            );
          } catch (err) {
            console.error(`Failed to upload ${file.name}`, err);
            showAlert(`Failed to upload file: ${file.name}`, [
              { label: "Ok", onClick: () => { }, color: "#c00" },
            ]);
          }
        }
      }

       showToast({
        message: parsedBody.message || "Referral added successfully"
      });

      onSubmit(finalData);
      onSave();
      onClose();

    } catch (error) {
      console.error("Referral submission error:", error);
      showAlert("Something went wrong while adding the referral. Check the console for details.", [
        { label: "Ok", onClick: () => { }, color: "var(--buttonColor)" },
      ]);
    } finally {
      stopHudRotation();
    }
  };

  const handleKeyDown = (e) => {

    const allowedKeys = [
        'Backspace',
        'ArrowLeft',
        'ArrowRight',
        'Delete',
        'Tab',
        '.'
    ];

    if (!allowedKeys.includes(e.key) && !e.key.match(/[0-9]/)) {
        e.preventDefault();
    }
    if (e.key === '.' && e.target.value.includes('.')) {
        e.preventDefault();
    }
};

  return {
    handleSubmit,
    title,
    users,
    customMake,
    accessLevel,
    customCounty,
    isDragging,
    formData,
    iscountyOther,
    customYear,
    handleDrop,
    handleDragOver,
    handleDragLeave,
    handleChange,
    isOtherSelected,
    isYearOther,
    setCustomMake,
    setCustomYear,
    setTittle,
    errors,
    setcustomCounty,
    setFormData,
    handleFileSelection,
    handleKeyDown,
    Years,
    VechileMakes,
    countyOptions
  };
}